import { render } from "./CalendarPrint.vue?vue&type=template&id=34cf9bc7&scoped=true"
import script from "./CalendarPrint.vue?vue&type=script&lang=js"
export * from "./CalendarPrint.vue?vue&type=script&lang=js"

import "./CalendarPrint.vue?vue&type=style&index=0&id=34cf9bc7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34cf9bc7"]])

export default __exports__